import { render, staticRenderFns } from "./Delivered.vue?vue&type=template&id=5f4af763&scoped=true&"
import script from "./Delivered.vue?vue&type=script&lang=js&"
export * from "./Delivered.vue?vue&type=script&lang=js&"
import style0 from "./Delivered.vue?vue&type=style&index=0&id=5f4af763&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4af763",
  null
  
)

export default component.exports